export default `---
slug: personal-website
title: "Personal Website"
year: 2025
category: personal
featured: false
tags: [React, Tailwind CSS, JavaScript, "Existential Crisis", Vibe Coding]
thumbnail: /images/projects/24_personal_website.jpg
description: "This website. The one you're reading right now. Started as a frontend learning exercise, became an introspective journey through everything I've built and lived."
relatedLinks: []
---
![personal website](/images/projects/24_personal_website.jpg)

This project is another ongoing adventure I kicked off in February 2025, and it's quite literally the website you're using right now to consume this very content. *(How meta is that?)*

It all started at the end of 2024 when I was doing my usual year-end reflection, thinking about my objectives for 2025. In the spirit of continuous learning and growth *(and keeping the kid — myself — busy)*, I wanted to explore something completely new.

Here's the thing though: I never touched frontend development. It felt like this mysterious, artistic realm that I wasn't ready for. But working with the brilliant guys from [Syllog](https://syllog.ai/en) gave me a little taste of it, and honestly? I got curious.

So I thought, "OK, 2025 is the year I'm gonna learn some frontend" — and the question became: what kind of website am I interested in building? Well, a website to speak about myself seemed like the perfect fit.

I dove in using React and Tailwind CSS as my frameworks, *because let's be honest, HTML and classical CSS are way too heavy and clunky for 2025.*

By now you know me, and of course I vibe coded a lot of the website, but I can actually maintain it and modify it when needed, and more importantly, I understand the AI's suggestions. *[You have no power](https://www.youtube.com/watch?v=ItZloH0XLHc) here, [MIT study.](https://www.media.mit.edu/publications/your-brain-on-chatgpt/)*

After I created the basic website structure, this whole "learning frontend" project transformed into something completely different. It's not so much about frontend creation anymore *(honestly, it's quite a basic website, not that much complexity)*. Now it's become this incredible content creation journey that forces me to reflect on my past, on myself, on everything I've done — all the projects, all the travels, the people in my life.

It's turned into this amazing introspective moment where I get to look back at the journey we call life and really see what I've accomplished so far.

And you know what?

*F-ck Imposter syndrome.* I actually deserve being where I am because I worked my ass off to get here. Sure, I got lucky with a lot of opportunities, but that doesn't diminish the effort I put in.

And for this website? **This is just the beginning.**

I intend to maintain this website from now on and keep updating it with new adventures and projects. It's kind of like my own little corner of the internet where I can share the ongoing story of this thing we call life, *to my only reader, my Mom.*
`;
